module.exports = __webpack_public_path__ + "static/media/menu.fc93691c.less";